/** API route map: URLS.Controller.CompanyOnboardingStatus */
export const CompanyOnboardingStatus = {
      Name: 'CompanyOnBoardingStatus/',
      GetCompanyOnboardingStatus: 'get-company-onboarding-status-list',
      AddCompanyOnboardingStatus: 'add-company-onboarding-status',
      UpdateCompanyOnboardingStatus: 'update-company-onboarding-status',
      DeleteCompanyOnboardingStatus: 'delete-company-onboarding-status',
      UpdateCompanyOnboardingStatusList: 'update-company-onboarding-status-list',
};
